import { Navigate, createBrowserRouter } from 'react-router-dom';

import { PublicOnlyRoute, RequireAuth } from '@/components/auth/RouteGuards';
import { AuthenticatedShell } from '@/components/layout/AuthenticatedShell';
import { DashboardPage } from '@/pages/dashboard/DashboardPage';
import { LoginPage } from '@/pages/auth/LoginPage';
import { InviteAcceptPage } from '@/pages/auth/InviteAcceptPage';
import { PasswordResetPage } from '@/pages/auth/PasswordResetPage';
import { NotFoundPage } from '@/pages/NotFoundPage';
import { SettingsPage } from '@/pages/settings/SettingsPage';
import { TenantDetailsPage } from '@/pages/tenants/TenantDetailsPage';
import { AuditPage } from '@/pages/AuditPage';
import { UsersPage } from '@/pages/users/UsersPage';

export const router = createBrowserRouter([
  {
    path: '/login',
    element: (
      <PublicOnlyRoute>
        <LoginPage />
      </PublicOnlyRoute>
    ),
  },
  {
    path: '/invite-accept',
    element: <InviteAcceptPage />,
  },
  {
    path: '/forgot-password',
    element: <PasswordResetPage />,
  },
  {
    path: '/password-reset',
    element: <PasswordResetPage />,
  },
  {
    path: '/',
    element: (
      <RequireAuth>
        <AuthenticatedShell />
      </RequireAuth>
    ),
    children: [
      {
        index: true,
        element: <DashboardPage />,
      },
      {
        path: 'access',
        element: <Navigate to="/users" replace />,
      },
      {
        path: 'users',
        element: <UsersPage />,
      },
      {
        path: 'tenants/:tenantId',
        element: <TenantDetailsPage />,
      },
      {
        path: 'settings',
        element: <SettingsPage />,
      },
      {
        path: 'audit',
        element: <AuditPage />,
      },
    ],
  },
  {
    path: '/home',
    element: <Navigate to="/" replace />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
], {
  future: {
    v7_relativeSplatPath: true,
    v7_fetcherPersist: true,
    v7_normalizeFormMethod: true,
    v7_partialHydration: true,
    v7_skipActionErrorRevalidation: true,
  },
});
